export function GlobalTagBadge() {
  return (
    <span
      title="Global"
      aria-label="Global"
      className="tw-inline-flex tw-h-3.5 tw-min-w-3.5 tw-shrink-0 tw-items-center tw-justify-center tw-rounded tw-bg-muted tw-px-0.5 tw-text-[9px] tw-font-medium tw-leading-none tw-text-muted-foreground"
    >
      G
    </span>
  );
}
